import { colorText, colorAccent, colorBackgroundBody, colorBorder } from '@/utils/palette';
import { marginRight, marginLeft, paddingLeft, paddingRight } from '@/utils/directions';
import styled from 'styled-components';

export const TopbarSearchInput = styled.input`
  width: 250px;
  height: 35px;
  margin-top: auto;
  border-radius: 13px;
  transition: border 0.3s;
  ${marginRight}: auto;
  ${marginLeft}: 0;
  ${paddingLeft}: 10px;
  ${paddingRight}: 46px;
  background-color: ${colorBackgroundBody};
  border: 1px solid ${colorBackgroundBody};
  color: ${colorText};
  max-width: 300px;

  &::placeholder {
    color: #cac1c1;
    ${paddingRight}: 50px;
  }

  &:focus,
  &:active {
    outline: none;
    border: 1px solid ${colorAccent};
  }

  @media screen and (min-width: 576px) {
    margin-bottom: auto;
    max-width: 350px;
  }
`;

export const LoadingWrap = styled.div`
  ${(props) => props.height && `height: ${props.height}vh`};
  display: flex;
  justify-content: center;
  font-size: 20px;
  align-items: center;
  /* height: 200px; */
`;

export const StyledNewTabPopup = styled.div`
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  color: ${colorText};
  background-color: ${colorBackgroundBody};

  &:hover {
    background-color: ${colorAccent};
    color: white;
    cursor: pointer;
  }
`;

export const TicketCounter = styled.p`
  font-weight: 600;
  color: #fff;
  background-color: #3258b7;
  padding: 1px 5px;
  margin-left: 8px;
  border-radius: 5px;
`;
export const ActionWrap = styled.div`
  display: flex;
  margin: 0 0 0 37px;
  padding-left: 10px;
  width: 86%;
  background-color: ${colorBackgroundBody};
  height: 70px;
  align-items: center;
  border: 1px solid ${colorBorder};
`;
